<template>
    <div class="c-timepicker">
        <div class="flex">
            <div class="c-timepicker__select margin-r-8">
                <select
                    ref="hour-select"
                    v-model="hour"
                    :data-error-container="'[data-error-message=\'' + 'timepicker-' + name + '\']'"
                    :name="name + '-hour'"
                    :required="required"
                    @change="update">
                    <option value=''></option>
                    <option v-for="n in 24" :value='n-1 | leadingzero' >{{n-1 | leadingzero}}</option>
                </select>
            </div>
            <div class="c-timepicker__select margin-l-8">
                <select
                    ref="minute-select"
                    v-model="minute"
                    :data-error-container="'[data-error-message=\'' + 'timepicker-' + name + '\']'"
                    :required="required"
                    :name="name + '-minute'"
                    @change="update">
                    <option value=''></option>
                    <option v-for="n in 60" :value='n-1 | leadingzero'>{{n-1 | leadingzero}}</option>
                </select>
            </div>
        </div>
        <div class="c-form__error" :data-error-message="'timepicker-' + name">Dit veld is verplicht.</div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            required: false,
            default: ''
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            hour: '',
            minute: '',
        }
    },
    watch: {
        value(value) {
            this.split();
        },

        hour(value) {

            if ( value == '' ) {
                this.minute = '';
            }
            else if ( this.minute == '' ) {
                this.minute = '00';
            }

            this.$nextTick( () => {
                var event = new Event('change');
                this.$refs['minute-select'].dispatchEvent(event);
            });
        },

        minute(value) {

            if ( value == '' ) {
                this.hour = '';
            }
            else if ( this.hour == '' ) {
                this.hour = '00';
            }

            this.$nextTick( () => {
                var event = new Event('change');
                this.$refs['hour-select'].dispatchEvent(event);
            });
        }
    },
    filters: {
        leadingzero(value) {

            if( value.toString().length == 1 ) {
                return '0' + value.toString();
            }

            return value.toString();
        }
    },
    methods: {
        split() {
            let [hour, minute] = this.value.split(':');

            this.hour = hour || '';
            this.minute = minute || '';
        },
        update() {
            if( this.minute && this.hour ){
                this.$emit('input', this.hour + ':' + this.minute);
            } else {
                this.$emit('input', '');
            }
        }
    },
    mounted() {
        if ( this.value ) {
            this.split();
        }
    }
}
</script>
